import StoriesUserLoved from "%/dynamic-component-editor/standard-pages/loved-stories-page/StoriesUserLoved.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyLovedStories extends LegacyEntity {
  get elements() {
    return {
      StoriesUserLoved,
    };
  }
}
